import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Summary = () => {
  const [chunksData, setChunksData] = useState([]);
  const [selectedModule, setSelectedModule] = useState('LM2001020201_요구사항확인');
  const [loading, setLoading] = useState(true);
  const [summaryData, setSummaryData] = useState({});
  
  // 학습모듈 목록 (일괄 처리 완료된 26개 모듈)
  const modules = [
    { id: 'LM2001020201_요구사항확인', name: '요구사항 확인', description: 'NCS 학습모듈 - 요구사항 확인' },
    { id: 'LM2001020205_데이터입출력구현', name: '데이터입출력구현', description: 'NCS 학습모듈 - 데이터입출력구현' },
    { id: 'LM2001020206_통합구현', name: '통합구현', description: 'NCS 학습모듈 - 통합구현' },
    { id: 'LM2001020208_정보시스템이행', name: '정보시스템이행', description: 'NCS 학습모듈 - 정보시스템이행' },
    { id: 'LM2001020209_제품소프트웨어패키징', name: '제품소프트웨어패키징', description: 'NCS 학습모듈 - 제품소프트웨어패키징' },
    { id: 'LM2001020211_서버프로그램구현', name: '서버프로그램구현', description: 'NCS 학습모듈 - 서버프로그램구현' },
    { id: 'LM2001020212_인터페이스구현', name: '인터페이스구현', description: 'NCS 학습모듈 - 인터페이스구현' },
    { id: 'LM2001020214_애플리케이션배포', name: '애플리케이션배포', description: 'NCS 학습모듈 - 애플리케이션배포' },
    { id: 'LM2001020217_애플리케이션리팩토링', name: '애플리케이션리팩토링', description: 'NCS 학습모듈 - 애플리케이션리팩토링' },
    { id: 'LM2001020218_인터페이스설계', name: '인터페이스설계', description: 'NCS 학습모듈 - 인터페이스설계' },
    { id: 'LM2001020219_애플리케이션요구사항분석', name: '애플리케이션요구사항분석', description: 'NCS 학습모듈 - 애플리케이션요구사항분석' },
    { id: 'LM2001020220_기능모델링', name: '기능모델링', description: 'NCS 학습모듈 - 기능모델링' },
    { id: 'LM2001020221_애플리케이션설계', name: '애플리케이션설계', description: 'NCS 학습모듈 - 애플리케이션설계' },
    { id: 'LM2001020222_정적모델설계', name: '정적모델설계', description: 'NCS 학습모듈 - 정적모델설계' },
    { id: 'LM2001020223_동적모델설계', name: '동적모델설계', description: 'NCS 학습모듈 - 동적모델설계' },
    { id: 'LM2001020224_화면설계', name: '화면설계', description: 'NCS 학습모듈 - 화면설계' },
    { id: 'LM2001020225_화면구현', name: '화면구현', description: 'NCS 학습모듈 - 화면구현' },
    { id: 'LM2001020226_애플리케이션테스트관리', name: '애플리케이션테스트관리', description: 'NCS 학습모듈 - 애플리케이션테스트관리' },
    { id: 'LM2001020227_애플리케이션테스트수행', name: '애플리케이션테스트수행', description: 'NCS 학습모듈 - 애플리케이션테스트수행' },
    { id: 'LM2001020228_소프트웨어공학활용', name: '소프트웨어공학활용', description: 'NCS 학습모듈 - 소프트웨어공학활용' },
    { id: 'LM2001020229_소프트웨어개발방법론활용', name: '소프트웨어개발방법론활용', description: 'NCS 학습모듈 - 소프트웨어개발방법론활용' },
    { id: 'LM2001020230_프로그래밍 언어 응용', name: '프로그래밍 언어 응용', description: 'NCS 학습모듈 - 프로그래밍 언어 응용' },
    { id: 'LM2001020231_프로그래밍 언어 활용', name: '프로그래밍 언어 활용', description: 'NCS 학습모듈 - 프로그래밍 언어 활용' },
    { id: 'LM2001020232_응용SW 기초 기술 활용', name: '응용SW 기초 기술 활용', description: 'NCS 학습모듈 - 응용SW 기초 기술 활용' },
    { id: 'LM2001020233_개발자 환경 구축', name: '개발자 환경 구축', description: 'NCS 학습모듈 - 개발자 환경 구축' },
    { id: 'LM2001020234_개발 환경 운영 지원', name: '개발 환경 운영 지원', description: 'NCS 학습모듈 - 개발 환경 운영 지원' }
  ];

  useEffect(() => {
    loadChunksData();
  }, [selectedModule]);

  const loadChunksData = async () => {
    try {
      setLoading(true);
      // JSONL 파일 로드 (public 폴더에서 접근)
      const response = await fetch('/all_chunks.jsonl');
      const text = await response.text();
      
      // JSONL 파싱 (각 줄이 JSON)
      const chunks = text
        .split('\n')
        .filter(line => line.trim())
        .map(line => JSON.parse(line));
      
      // 선택된 모듈의 데이터만 필터링
      const moduleChunks = chunks.filter(chunk => chunk.doc_id === selectedModule);
      
      setChunksData(moduleChunks);
      generateSummary(moduleChunks);
    } catch (error) {
      console.error('청크 데이터 로드 실패:', error);
      // 에러 시 더미 데이터로 테스트
      generateDummyData();
    } finally {
      setLoading(false);
    }
  };
  
  // 에러 시 더미 데이터 생성
  const generateDummyData = () => {
    const dummyData = {
      "1": {
        title: "현행 시스템 분석하기",
        topics: {
          "1-1": {
            title: "현행 시스템 파악",
            chunks: [{ text: "현행 시스템 파악은 개발하고자 하는 시스템의 이해를 위해 필요한 과정입니다.", length: 50 }],
            keyTerms: ["현행 시스템", "시스템 분석", "요구사항"],
            contentTypes: ["정의", "절차"]
          }
        },
        totalChunks: 1,
        totalLength: 50
      },
      "2": {
        title: "요구사항 정의",
        topics: {
          "2-1": {
            title: "요구사항 정의",
            chunks: [{ text: "요구사항 정의는 시스템이 수행해야 할 기능과 제약사항을 명시하는 과정입니다.", length: 45 }],
            keyTerms: ["요구사항", "기능요구사항", "비기능요구사항"],
            contentTypes: ["정의"]
          }
        },
        totalChunks: 1,
        totalLength: 45
      },
      "3": {
        title: "분석모델 확인하기",
        topics: {
          "3-1": {
            title: "분석모델 검증",
            chunks: [{ text: "분석모델 검증은 작성된 분석모델의 정확성과 완전성을 확인하는 과정입니다.", length: 42 }],
            keyTerms: ["분석모델", "검증", "타당성"],
            contentTypes: ["절차"]
          }
        },
        totalChunks: 1,
        totalLength: 42
      }
    };
    setSummaryData(dummyData);
  };

  const generateSummary = (chunks) => {
    const summary = {};
    
    // 학습모듈별로 그룹화
    const groupedByLesson = chunks.reduce((acc, chunk) => {
      const lesson = chunk.lesson_num;
      if (!acc[lesson]) {
        acc[lesson] = {
          title: chunk.lesson_title,
          topics: {},
          totalChunks: 0,
          totalLength: 0
        };
      }
      
      acc[lesson].totalChunks++;
      acc[lesson].totalLength += chunk.length;
      
      // 토픽별 그룹화
      const topicId = chunk.topic_id;
      if (!acc[lesson].topics[topicId]) {
        acc[lesson].topics[topicId] = {
          title: chunk.topic_title,
          chunks: [],
          keyTerms: new Set(),
          contentTypes: []
        };
      }
      
      acc[lesson].topics[topicId].chunks.push(chunk);
      
      // 키워드 추출 (간단한 버전)
      const keywords = extractKeywords(chunk.text);
      keywords.forEach(keyword => acc[lesson].topics[topicId].keyTerms.add(keyword));
      
      // 내용 유형 추가
      if (chunk.annotations && chunk.annotations.type) {
        acc[lesson].topics[topicId].contentTypes.push(...chunk.annotations.type);
      }
      
      return acc;
    }, {});
    
    // Set을 Array로 변환
    Object.keys(groupedByLesson).forEach(lesson => {
      Object.keys(groupedByLesson[lesson].topics).forEach(topicId => {
        groupedByLesson[lesson].topics[topicId].keyTerms = 
          Array.from(groupedByLesson[lesson].topics[topicId].keyTerms);
      });
    });
    
    setSummaryData(groupedByLesson);
  };

  const extractKeywords = (text) => {
    // 간단한 키워드 추출 (한글 기술용어 중심)
    const techTerms = text.match(/[가-힣]{2,}(?:시스템|모델|방법|기법|분석|설계|구현|테스트|관리|요구사항|인터페이스|아키텍처|소프트웨어|하드웨어|네트워크|데이터베이스)/g) || [];
    const definitions = text.match(/[가-힣]{3,}(?:이란|란|의 정의|개념)/g) || [];
    
    return [...new Set([...techTerms, ...definitions])].slice(0, 5);
  };

  const getSelectedModuleInfo = () => {
    return modules.find(module => module.id === selectedModule) || modules[0];
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">학습 내용을 분석하고 있습니다...</p>
        </div>
      </div>
    );
  }

  const selectedModuleInfo = getSelectedModuleInfo();
  const lessonKeys = Object.keys(summaryData).sort();

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-6xl mx-auto px-4">
        {/* 헤더 */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">📚 학습 요약정리</h1>
          <p className="text-gray-600 mb-6">NCS 학습모듈의 핵심 내용을 정리하여 제공합니다.</p>
          
          {/* 학습모듈 선택 */}
          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              학습모듈 선택
            </label>
            <select
              value={selectedModule}
              onChange={(e) => setSelectedModule(e.target.value)}
              className="w-full max-w-md px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
            >
              {modules.map(module => (
                <option key={module.id} value={module.id}>
                  {module.name}
                </option>
              ))}
            </select>
            <p className="text-sm text-gray-500 mt-1">
              {selectedModuleInfo.description}
            </p>
          </div>
        </div>

        {/* 선택된 모듈의 학습 목차 */}
        <div className="mb-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">
            📋 {selectedModuleInfo.name} - 학습 목차
          </h2>
          
          {lessonKeys.length > 0 ? (
            <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
              {lessonKeys.map((lessonNum) => {
                const lessonData = summaryData[lessonNum];
                return (
                  <Link
                    key={lessonNum}
                    to={`/summary/lesson/${selectedModule}/${lessonNum}`}
                    className="block"
                  >
                    <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 hover:scale-105 cursor-pointer">
                      {/* 학습 헤더 */}
                      <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white p-4">
                        <h3 className="text-lg font-bold mb-2">
                          학습 {lessonNum}. {lessonData.title}
                        </h3>
                        <div className="flex gap-3 text-blue-100 text-sm">
                          <span>📄 {lessonData.totalChunks}개 섹션</span>
                          <span>🎯 {Object.keys(lessonData.topics).length}개 토픽</span>
                        </div>
                        <div className="mt-2 text-blue-100 text-sm">
                          📖 클릭하여 상세보기
                        </div>
                      </div>

                      {/* 토픽 목록 */}
                      <div className="p-4">
                        <div className="space-y-3">
                          {Object.entries(lessonData.topics).map(([topicId, topicData]) => (
                            <div key={topicId} className="border-l-4 border-blue-200 pl-3 py-2">
                              <h4 className="font-medium text-gray-900 mb-1">
                                {topicId}. {topicData.title}
                              </h4>
                              <p className="text-sm text-gray-600 mb-2">
                                📑 {topicData.chunks.length}개 섹션
                              </p>
                              
                              {/* 주요 키워드 (간단히) */}
                              {topicData.keyTerms.length > 0 && (
                                <div className="flex flex-wrap gap-1">
                                  {topicData.keyTerms.slice(0, 3).map((term, index) => (
                                    <span 
                                      key={index}
                                      className="px-2 py-1 bg-gray-100 text-gray-700 text-xs rounded"
                                    >
                                      {term}
                                    </span>
                                  ))}
                                  {topicData.keyTerms.length > 3 && (
                                    <span className="text-xs text-gray-500">
                                      +{topicData.keyTerms.length - 3}개
                                    </span>
                                  )}
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </Link>
                );
              })}
            </div>
          ) : (
            <div className="text-center py-12">
              <div className="text-gray-400 text-6xl mb-4">📚</div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">학습 내용을 불러오는 중...</h3>
              <p className="text-gray-600">잠시만 기다려주세요.</p>
            </div>
          )}
        </div>

        {/* 모듈 통계 */}
        <div className="mt-8 bg-white rounded-xl shadow-lg p-6">
          <h2 className="text-xl font-bold mb-4">📊 {selectedModuleInfo.name} 통계</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div className="text-center p-4 bg-blue-50 rounded-lg">
              <div className="text-2xl font-bold text-blue-600">{lessonKeys.length}</div>
              <div className="text-sm text-gray-600">학습 단위</div>
            </div>
            <div className="text-center p-4 bg-green-50 rounded-lg">
              <div className="text-2xl font-bold text-green-600">
                {Object.values(summaryData).reduce((sum, lesson) => sum + Object.keys(lesson.topics).length, 0)}
              </div>
              <div className="text-sm text-gray-600">총 토픽</div>
            </div>
            <div className="text-center p-4 bg-purple-50 rounded-lg">
              <div className="text-2xl font-bold text-purple-600">
                {Object.values(summaryData).reduce((sum, lesson) => sum + lesson.totalChunks, 0)}
              </div>
              <div className="text-sm text-gray-600">총 섹션</div>
            </div>
            <div className="text-center p-4 bg-orange-50 rounded-lg">
              <div className="text-2xl font-bold text-orange-600">
                {Math.round(Object.values(summaryData).reduce((sum, lesson) => sum + lesson.totalLength, 0) / 1000)}K
              </div>
              <div className="text-sm text-gray-600">총 글자 수</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Summary;